/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompteBancaireLightDto } from './CompteBancaireLightDto';
import {
    CompteBancaireLightDtoFromJSON,
    CompteBancaireLightDtoFromJSONTyped,
    CompteBancaireLightDtoToJSON,
    CompteBancaireLightDtoToJSONTyped,
} from './CompteBancaireLightDto';

/**
 * Ré-assureur d'une garantie du tunnel. Les clés XS / PorteeXS / AttachementXS / QP sont sérialisées en PascalCase par le back : ne pas les renommer.
 * @export
 * @interface ReAssureurDto
 */
export interface ReAssureurDto {
    /**
     * 
     * @type {string}
     * @memberof ReAssureurDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReAssureurDto
     */
    personneMoraleId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReAssureurDto
     */
    designation?: string | null;
    /**
     * Code sous-nature de la compagnie (MUT, REA…), null pour un assureur classique.
     * @type {string}
     * @memberof ReAssureurDto
     */
    sousNature?: string | null;
    /**
     * 
     * @type {CompteBancaireLightDto}
     * @memberof ReAssureurDto
     */
    compteBancaire?: CompteBancaireLightDto;
    /**
     * 
     * @type {number}
     * @memberof ReAssureurDto
     */
    tauxQP?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReAssureurDto
     */
    xS?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReAssureurDto
     */
    porteeXS?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReAssureurDto
     */
    attachementXS?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReAssureurDto
     */
    qP?: boolean;
}

/**
 * Check if a given object implements the ReAssureurDto interface.
 */
export function instanceOfReAssureurDto(value: object): value is ReAssureurDto {
    return true;
}

export function ReAssureurDtoFromJSON(json: any): ReAssureurDto {
    return ReAssureurDtoFromJSONTyped(json, false);
}

export function ReAssureurDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReAssureurDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'personneMoraleId': json['personneMoraleId'] == null ? undefined : json['personneMoraleId'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'sousNature': json['sousNature'] == null ? undefined : json['sousNature'],
        'compteBancaire': json['compteBancaire'] == null ? undefined : CompteBancaireLightDtoFromJSON(json['compteBancaire']),
        'tauxQP': json['tauxQP'] == null ? undefined : json['tauxQP'],
        'xS': json['XS'] == null ? undefined : json['XS'],
        'porteeXS': json['PorteeXS'] == null ? undefined : json['PorteeXS'],
        'attachementXS': json['AttachementXS'] == null ? undefined : json['AttachementXS'],
        'qP': json['QP'] == null ? undefined : json['QP'],
    };
}

export function ReAssureurDtoToJSON(json: any): ReAssureurDto {
    return ReAssureurDtoToJSONTyped(json, false);
}

export function ReAssureurDtoToJSONTyped(value?: ReAssureurDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personneMoraleId': value['personneMoraleId'],
        'designation': value['designation'],
        'sousNature': value['sousNature'],
        'compteBancaire': CompteBancaireLightDtoToJSON(value['compteBancaire']),
        'tauxQP': value['tauxQP'],
        'XS': value['xS'],
        'PorteeXS': value['porteeXS'],
        'AttachementXS': value['attachementXS'],
        'QP': value['qP'],
    };
}

